<template>
    <div class="sustainable-component admin-company" style="position:relative;">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-company-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row px-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa företag" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-text-field bg-color="white"
                                                      :rules="[rules.required]"
                                                      name="CompanyName"
                                                      id="CompanyName"
                                                      type="text"
                                                      label="Företagsnamn"
                                                      variant="outlined"
                                                      v-model="company.Name"></v-text-field>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <v-autocomplete bg-color="white"
                                                        variant="outlined"
                                                        name="Club"
                                                        :rules="[rules.requiredSelection]"
                                                        v-model="company.ClubId"
                                                        item-title="ClubName"
                                                        item-value="ClubId"
                                                        :items="getClubs()"
                                                        label="Klubb"
                                                        clearable>
                                        </v-autocomplete>
                                        <v-autocomplete bg-color="white"
                                                        variant="outlined"
                                                        name="WorkSpace"
                                                        :rules="[rules.requiredSelection]"
                                                        v-model="company.WorkspaceId"
                                                        item-title="WorkspaceName"
                                                        item-value="WorkspaceId"
                                                        :items="getWorkspaces()"
                                                        label="Arbetsplats"
                                                        clearable>
                                        </v-autocomplete>
                                        <v-autocomplete bg-color="white"
                                                        variant="outlined"
                                                        name="UserId"
                                                        :rules="[rules.requiredSelection]"
                                                        v-model="company.UserId"
                                                        item-title="Username"
                                                        item-value="UserId"
                                                        :items="getUsers()"
                                                        label="Användare"
                                                        clearable>
                                        </v-autocomplete>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="company-create-actions">
                                            <v-btn variant="tonal" @click="createCompany" class="bg-primary">
                                                Skapa
                                            </v-btn>
                                            <ExampleCompanyMenu :items="availableExampleCompanies"
                                                                @select="createExampleCompany"></ExampleCompanyMenu>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space p-3">
                <b>Visar {{getCompanies().length}} av {{companies.length}} företag</b>
                <div class="mt-3">
                    <v-text-field @change="loadCompanies" bg-color="white"
                                  name="FilterCompanyName"
                                  id="FilterCompanyName"
                                  type="text"
                                  label="Filtrera på företagsnamn, email eller avdelningsnamn"
                                  variant="outlined"
                                  v-model="filter"
                                  focused="true"></v-text-field>
                </div>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Namn</th>
                            <th class="col-2">Status</th>

                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in getCompanies()" :key="index">
                            <td>{{item.Name}}</td>
                            <td>{{item.Status}}</td>

                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCompany(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="copyCompany(item)">Kopiera</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteCompany(item.CompanyId)">Ta bort permanent</a>
                                            <a v-if="item.IntStatus == 10" href="javascript:void(0)" class="dropdown-item" @click="setCompanyDeleted(item.CompanyId)">Markera som borttagen</a>
                                            <a v-if="item.IntStatus == 30" href="javascript:void(0)" class="dropdown-item" @click="reactivateCompany(item.CompanyId)">Återaktivera</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <AdminUpdateCompanyDepartment ref="updateCompanyModal" @updated="loadCompanies"></AdminUpdateCompanyDepartment>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>
    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import AdminUpdateCompanyDepartment from './update/update-company-department.vue'
    import ExampleCompanyMenu from './common/example-company-menu.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateCompanyModal = ref(null);
    export default {

        name: 'admin-company-department',
        props: {

        },
        components: {
            CommonLabelContainer,
            AdminUpdateCompanyDepartment,
            ExampleCompanyMenu,
            CommonSpinner
        },
        methods: {
            async validateCreateForm() {
                const result = await this.form.validate();
                if (result.valid === true) {
                    return true;
                }

                const missingFields = [];
                if (!this.company.Name) {
                    missingFields.push("företagsnamn");
                }
                if (!(this.company.ClubId > 0)) {
                    missingFields.push("klubb");
                }
                if (!(this.company.WorkspaceId > 0)) {
                    missingFields.push("arbetsplats");
                }
                if (!(this.company.UserId > 0)) {
                    missingFields.push("användare");
                }

                if (missingFields.length > 0) {
                    this.displayErrorSnackBar("Fyll i följande innan du skapar företaget: " + missingFields.join(", ") + ".");
                }
                else {
                    this.displayErrorSnackBar("Fyll i obligatoriska fält innan du skapar företaget.");
                }

                return false;
            },
            async createCompany() {
                if (!(await this.validateCreateForm())) {
                    return;
                }

                this.loading++;
                try {
                    await AdminService.createCompany(this.company);
                    this.displaySnackBar("Bolaget skapades");
                }
                catch (error) {
                    this.displayErrorSnackBar(this.getErrorMessage(error));
                    return;
                }
                finally {
                    this.loading--;
                }

                window.refreshCompanies();
                await this.loadCompanies();
            },
            async createExampleCompany(item) {
                if (!(await this.validateCreateForm())) {
                    return;
                }

                this.loading++;
                try {
                    await AdminService.createCompanyFromExample({
                        ...this.company,
                        ExampleCompanyId: item.CompanyId
                    });
                    this.displaySnackBar("Bolaget skapades från exempel");
                }
                catch (error) {
                    this.displayErrorSnackBar(this.getErrorMessage(error));
                    return;
                }
                finally {
                    this.loading--;
                }

                window.refreshCompanies();
                await this.loadCompanies();
            },
            async copyCompany(company) {
                this.loading++;
                var idToCopy = company.CompanyId;
                var nameOfCopy = company.Name + "_kopia";

                try{
                    await AdminService.copyCompany(idToCopy, nameOfCopy);
                    this.displaySnackBar("Bolaget kopierades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch(error){
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async deleteCompany(companyId) {
                if (confirm("Är du säker att du vill radera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteCompany(companyId);
                        this.displaySnackBar("Bolaget togs bort");
                        this.loadCompanies();
                        window.refreshCompanies()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async setCompanyDeleted(companyId) {
                if (confirm("Är du säker att du vill markera bolaget som raderat?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyDeleted(companyId);
                        this.displaySnackBar("Bolaget togs bort");
                        this.loadCompanies();
                        window.refreshCompanies()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async reactivateCompany(companyId) {
                if (confirm("Är du säker att du vill återaktivera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyActive(companyId);
                        this.displaySnackBar("Bolaget återaktiverades");
                        window.refreshCompanies()
                        this.loadCompanies();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async loadCompanies() {
                this.loading++;
                try {
                    this.companies = await AdminService.getDepartmentCompanies(this.filter);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateCompany(company) {
                this.loading++;
                this.updateCompanyModal.open(company)
                this.loading--;
            },
            async loadClubs() {
                this.loading++;
                try {
                    this.clubs = await AdminService.getDepartmentClubs();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadWorkspaces(clubId) {
                this.loading++;
                try {
                    this.workspaces = await AdminService.getWorkspacesFromClub(clubId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadUsers() {
                this.loading++;
                try {
                    this.users = await AdminService.getWorkspaceUsers();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadAvailableExampleCompanies() {
                this.loading++;
                try {
                    this.availableExampleCompanies = await AdminService.getAvailableExampleCompanies();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getUsers() {
                return this.users;
            },
            getWorkspaces() {
                return this.workspaces;
            },
            getClubs() {
                return this.clubs;
            },
            matchesSelectedId(itemValue, selectedValue) {
                if (selectedValue == null || selectedValue === '' || !(Number(selectedValue) > 0)) {
                    return true;
                }

                return Number(itemValue) === Number(selectedValue);
            },
            getCompanies() {
                return this.companies.filter(item =>
                    this.matchesSelectedId(item.ClubId, this.company.ClubId) &&
                    this.matchesSelectedId(item.WorkspaceId, this.company.WorkspaceId) &&
                    this.matchesSelectedId(item.UserId, this.company.UserId)
                );
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            getErrorMessage(error) {
                if (error && error.data && Array.isArray(error.data) && error.data.length > 0) {
                    return error.data.join(" ");
                }
                if (error && error.response && error.response.data && Array.isArray(error.response.data) && error.response.data.length > 0) {
                    return error.response.data.join(" ");
                }

                return "Ett oväntat fel har inträffat";
            },
        },

        data() {
            return {
                filter: null,
                valid: false,
                rules: ValidationService.rules(),
                companyloaded: false,
                company: {
                    DepartmentId: null,
                    ClubId: null,
                    WorkspaceId: null,
                    Name: '',
                    UserId: null,
                },
                companies: [],
                availableExampleCompanies: [],
                copyName: null,
                clubs: [],
                workspaces: [],
                users: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            'company.ClubId': function (newVal) {
                this.company.WorkspaceId = null;
                if (newVal != null && Number(newVal) > 0) {
                    this.loadWorkspaces(newVal);
                }
                else {
                    this.workspaces = [];
                }
            },
        },
        mounted() {
            this.loadCompanies();
            this.loadClubs();
            this.loadUsers();
            this.loadAvailableExampleCompanies();
        },
        setup() {
            return { form, updateCompanyModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
